import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Portal from './../common/Portal';
import Button from './Button';

import './MobilePopover.css';

class MobilePopover extends React.Component {

  static propTypes = {
    vertical: PropTypes.bool,
    children: PropTypes.any
  }

  state = {
    show: false
  }

  onToggle = () => {
    this.setState({ show: !this.state.show });
  }

  render() {
    const { vertical, children } = this.props;
    const { show } = this.state;

    return (
      <div name="MobilePopover" className={classNames({ vertical })}>
        <Button icon="images/more.svg" onClick={this.onToggle} />
        {show ?
          <Portal defaultOpen={show} closeOnOutsideClick={true}>
            <div name="MobilePopover_Portal" onClick={this.onToggle}>
              <div className="content">
                {children}
              </div>
            </div>
          </Portal> : null}
      </div>
    );
  }

}

export default MobilePopover;
